import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const modules = {
    auth,
}

export default new Vuex.Store({
    // plugins: [createPersistedState()],
    modules,
    state: {},
    getters: {},
    mutations: {},
    actions: {}
})